module.exports = require("utf-8-validate");